import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root"
})
export class ValidatesCertificateService {
    private relativePath: string;

    constructor(private httpClient: HttpClient) {
        this.relativePath = `${environment.userCourses.url}/api/v1/validates-certificate`;
    }

    public GetCertificationUrl(id: string, subscriptionId: string, token: string): Observable<string> {
        const param = new HttpParams().set("token", token).set("subscriptionId", subscriptionId);

        return this.httpClient.get(`${this.relativePath}/${id}`, { params: param, responseType: "text" });
    }
}
